import * as React from "react";
import HusklyLogo from "../HusklyLogo";

const Footer = () => (
  <footer className="border-t border-stone-200 bg-stone-50">
    <div className="max-w-6xl mx-auto px-6 sm:px-10 py-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
      <div className="flex items-center gap-2.5">
        <HusklyLogo
          className="w-5 h-5 text-stone-900"
          style={{ fill: "currentColor" }}
        />
        <span className="font-serif text-lg text-stone-900">Huskly</span>
        <span className="text-sm text-stone-500 ml-3">
          © {new Date().getFullYear()}
        </span>
      </div>
      <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-stone-600">
        <a
          href="https://github.com/orgs/huskly/repositories"
          target="_blank"
          rel="noreferrer"
          className="hover:text-stone-900 transition-colors"
        >
          GitHub
        </a>
      </nav>
    </div>
  </footer>
);

export default Footer;
